const Magnifier = ({ color, type }) => {
  const regular = (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.62673 2.06673C4.10831 2.06673 2.06673 4.10831 2.06673 6.62673C2.06673 9.14515 4.10831 11.1867 6.62673 11.1867C7.86846 11.1867 8.99426 10.6904 9.81659 9.88533C9.81769 9.88424 9.8188 9.88315 9.81992 9.88206C10.6634 9.05454 11.1867 7.90175 11.1867 6.62673C11.1867 4.10831 9.14515 2.06673 6.62673 2.06673ZM11.2118 10.3295C12.03 9.31759 12.5201 8.02939 12.5201 6.62673C12.5201 3.37193 9.88153 0.733398 6.62673 0.733398C3.37193 0.733398 0.733398 3.37193 0.733398 6.62673C0.733398 9.88153 3.37193 12.5201 6.62673 12.5201C7.99835 12.5201 9.26053 12.0515 10.2619 11.2657L12.1365 13.0792C12.4012 13.3352 12.8232 13.3282 13.0792 13.0636C13.3352 12.799 13.3282 12.3769 13.0636 12.1209L11.2118 10.3295Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Magnifier;
